import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const BaggageEmptyIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.05 6.20528V2.5584C7.05 2.25 7.29624 2 7.6 2H16.4C16.7038 2 16.95 2.25 16.95 2.5584V6.20528H22.1091C22.6011 6.20528 23 6.61026 23 7.10983V21.0954C23 21.595 22.6011 22 22.1091 22H1.89095C1.39889 22 1 21.595 1 21.0954V7.10983C1 6.61026 1.39889 6.20528 1.89095 6.20528H7.05ZM8.15 6.20528H15.85V3.44876C15.85 3.1615 15.6206 2.92864 15.3377 2.92864H8.6623C8.37936 2.92864 8.15 3.1615 8.15 3.44876V6.20528ZM2.56007 8.03046V20.3925H21.4399V8.03046H2.56007Z'
                fill='currentColor'
            />
        </>
    ),
})

BaggageEmptyIcon.displayName = 'BaggageEmptyIcon'
